var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.dropdown)?_c('ComposedDropdownContractAddresses',{attrs:{"contracts":_setup.contracts}}):_c('ComposedListTokenImport',{attrs:{"direction":"column","contracts":_setup.contracts}})
}
var staticRenderFns = []

export { render, staticRenderFns }